export function getView(treatment_plans) {
  return treatment_plans?.length && treatment_plans.length > 1
}
